import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api, { getImageUrl } from '../api/api';
import './Blog.css';

function BlogCard({ post }) {
  return (
    <article className="blog-card">
      <Link to={`/blog/${post.slug}`} className="blog-card-img-wrap">
        <img
          src={getImageUrl(post.image)}
          alt={post.title}
          onError={e => { e.target.src = '/images/scooter-1.jpg'; }}
        />
        {post.category && <span className="blog-card-cat">{post.category}</span>}
      </Link>
      <div className="blog-card-body">
        <div className="blog-card-meta">
          <span className="blog-card-date">
            {new Date(post.createdAt).toLocaleDateString('en-IE', { day: 'numeric', month: 'long', year: 'numeric' })}
          </span>
          {post.author && <><span className="blog-meta-sep">·</span><span className="blog-card-author">{post.author}</span></>}
        </div>
        <h2 className="blog-card-title">
          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
        </h2>
        <p className="blog-card-excerpt">{post.excerpt}</p>
        <Link to={`/blog/${post.slug}`} className="blog-read-more">
          Read More <span>→</span>
        </Link>
      </div>
    </article>
  );
}

function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('All');
  const [categories, setCategories] = useState(['All']);

  useEffect(() => {
    api.get('/blog')
      .then(({ data }) => {
        setPosts(data);
        const cats = ['All', ...new Set(data.map(p => p.category).filter(Boolean))];
        setCategories(cats);
      })
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = activeCategory === 'All' ? posts : posts.filter(p => p.category === activeCategory);
  const featured = filtered[0];
  const rest = filtered.slice(1);

  return (
    <div className="blog-page">

      {/* Page Hero */}
      <div className="blog-hero">
        <div className="container">
          <span className="blog-hero-tag">Gift Guide Blog</span>
          <h1>The Perfect E-Scooter for Every Occasion</h1>
          <p>Looking for a gift that's exciting, eco-friendly, and genuinely useful? Explore our guides to find the ideal electric scooter for any celebration.</p>
          <a href="/products" className="blog-hero-cta">Browse All Scooters</a>
        </div>
      </div>

      <div className="container blog-container">

        {/* Category Filter */}
        {categories.length > 1 && (
          <div className="blog-filter">
            {categories.map(cat => (
              <button
                key={cat}
                className={activeCategory === cat ? 'active' : ''}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        )}

        {loading && <div className="blog-loading">Loading posts...</div>}

        {!loading && filtered.length === 0 && (
          <div className="blog-empty">No posts found.</div>
        )}

        {/* Featured post — first card large */}
        {!loading && featured && (
          <article className="blog-featured">
            <Link to={`/blog/${featured.slug}`} className="blog-featured-img-wrap">
              <img
                src={getImageUrl(featured.image)}
                alt={featured.title}
                onError={e => { e.target.src = '/images/scooter-1.jpg'; }}
              />
              {featured.category && <span className="blog-card-cat">{featured.category}</span>}
            </Link>
            <div className="blog-featured-body">
              <div className="blog-card-meta">
                <span className="blog-card-date">
                  {new Date(featured.createdAt).toLocaleDateString('en-IE', { day: 'numeric', month: 'long', year: 'numeric' })}
                </span>
                {featured.author && <><span className="blog-meta-sep">·</span><span className="blog-card-author">{featured.author}</span></>}
              </div>
              <h2 className="blog-featured-title">
                <Link to={`/blog/${featured.slug}`}>{featured.title}</Link>
              </h2>
              <p className="blog-featured-excerpt">{featured.excerpt}</p>
              <Link to={`/blog/${featured.slug}`} className="btn blog-featured-btn">Read Article →</Link>
            </div>
          </article>
        )}

        {/* Grid of remaining posts */}
        {!loading && rest.length > 0 && (
          <div className="blog-grid">
            {rest.map(post => <BlogCard key={post._id} post={post} />)}
          </div>
        )}

      </div>
    </div>
  );
}

export default Blog;
